export default __webpack_public_path__ + "static/proxima-nova-900-i-146e626add8e7f9564ae54ceeb0d3efc.woff";